import * as React from "react";
const MakeIntegrationIcon = (props) => (
  <svg
    height="1em"
    style={{
      flex: "none",
      lineHeight: 1,
    }}
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{"Make"}</title>
    <path
      d="M6.989 4.036L.062 17.818a.577.577 0 00.257.774l3.733 1.876a.577.577 0 00.775-.256L11.753 6.43a.577.577 0 00-.257-.775L7.763 3.78a.575.575 0 00-.774.257z"
      fill="url(#lobe-icons-make-fill-0)"
    />
    <path
      d="M19.245 3.832h4.179c.318 0 .577.26.577.577v15.425a.578.578 0 01-.577.578h-4.179a.578.578 0 01-.577-.578V4.41c0-.318.259-.577.577-.577z"
      fill="url(#lobe-icons-make-fill-1)"
    />
    <path
      d="M12.815 4.085L9.85 19.108a.576.576 0 00.453.677l4.095.826c.314.063.62-.14.681-.454l2.964-15.022a.577.577 0 00-.453-.677l-4.096-.827a.577.577 0 00-.68.454z"
      fill="url(#lobe-icons-make-fill-2)"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="lobe-icons-make-fill-0"
        x1={1.5}
        x2={12}
        y1={19.5}
        y2={0}
      >
        <stop stopColor="#F0F" />
        <stop offset={0.17} stopColor="#E90CF9" />
        <stop offset={0.54} stopColor="#C023ED" />
        <stop offset={0.73} stopColor="#B02DE9" />
        <stop offset={1} stopColor="#B02DE9" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="lobe-icons-make-fill-1"
        x1={0}
        x2={24}
        y1={24}
        y2={0}
      >
        <stop stopColor="#B02DE9" />
        <stop offset={0.02} stopColor="#B02DE9" />
        <stop offset={0.8} stopColor="#6D00CC" />
        <stop offset={1} stopColor="#6D00CC" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="lobe-icons-make-fill-2"
        x1={0}
        x2={24}
        y1={24}
        y2={0}
      >
        <stop stopColor="#F0F" />
        <stop offset={0.02} stopColor="#F0F" />
        <stop offset={0.09} stopColor="#E90CF9" />
        <stop offset={0.23} stopColor="#C023ED" />
        <stop offset={0.3} stopColor="#B02DE9" />
        <stop offset={0.42} stopColor="#A42BE3" />
        <stop offset={0.63} stopColor="#8626D5" />
        <stop offset={0.85} stopColor="#6021C3" />
        <stop offset={1} stopColor="#6021C3" />
      </linearGradient>
    </defs>
  </svg>
);
export default MakeIntegrationIcon;
